import * as React from 'react';
import { CalendarDays, X } from 'lucide-react';
import { cn } from '@/lib/utils';

interface DatePickerTriggerProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  displayText?: string;
  hasValue: boolean;
  onClear: () => void;
}

export const DatePickerTrigger = React.forwardRef<HTMLButtonElement, DatePickerTriggerProps>(
  ({ label, displayText, hasValue, onClear, className, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        data-testid="date-picker-trigger"
        className={cn(
          'inline-flex h-9 cursor-pointer items-center gap-1.5 rounded-md border bg-background px-3 text-sm font-normal transition-colors hover:bg-accent focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          hasValue ? 'border-primary/50 text-foreground' : 'border-input text-muted-foreground',
          className,
        )}
        {...rest}
      >
        <CalendarDays className="h-3.5 w-3.5 shrink-0" />
        <span>{hasValue ? displayText : label}</span>
        {hasValue && (
          <span
            role="button"
            aria-label="清除"
            className="ml-0.5 rounded-sm p-0.5 hover:bg-muted-foreground/20"
            onClick={(e) => {
              e.stopPropagation();
              onClear();
            }}
          >
            <X className="h-3 w-3" />
          </span>
        )}
      </button>
    );
  },
);

DatePickerTrigger.displayName = 'DatePickerTrigger';
